module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "留言"
    },
    on: {
      "click": _vm.submit
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df0d5aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSubmit.vue
// module id = 69
// module chunks = 0